import mutations from "./mutations";
import actions from "./actions";

const state = {
  allUsersForNimasaAdmin: [],
  allUsersForPort: [],
  allUsersForNimasaAgent: [],
  allUsersForNimasaManager: []
};

const getters = {
  getAllUsersForPort: state => {
    const list = state.allUsersForPort.map(user => ({
      id: user.id,
      created_at: user.created_at,
      user_name: user.user_name,
      full_name: user.full_name,
      email: user.email,
      role: "Port User"
    }));
    return list;
  },
  getAllUsersForNimasaAdminUser: state => {
    const list = state.allUsersForNimasaAdmin.map(user => ({
      id: user.id,
      created_at: user.created_at,
      user_name: user.user_name,
      full_name: user.full_name,
      email: user.email,
      role: "NIMASA Admin User"
    }));
    return list;
  },
  getAllUsersForNimasaAgent: state => {
    const list = state.allUsersForNimasaAgent.map(user => ({
      id: user.id,
      created_at: user.created_at,
      user_name: user.user_name,
      full_name: user.full_name,
      email: user.email,
      role: "NIMASA Agent"
    }));
    return list;
  },
  getAllUsersForNimasaManager: state => {
    const list = state.allUsersForNimasaManager.map(user => ({
      id: user.id,
      created_at: user.created_at,
      user_name: user.user_name,
      full_name: user.full_name,
      email: user.email,
      role: "NIMASA Manager"
    }));
    return list;
  },

  isNimasaAdmin: (state, getters, rootState) => {
    return rootState.userRoles[0] === "NIMASA_ADMIN";
  },

  isHudsontridentUser: (state, getters, rootState) => {
    return rootState.userRoles[0] === "ADMIN_USER";
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
